import { number } from "prop-types";
import { Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { CELL_PADDING, CELL_WIDTHS } from "@utils";

export const TimelineSectionDivider = ({ tableDepth=0 }) => {
  const classes = useStyle({ tableDepth });

  return <Divider className={classes.root} />
}

TimelineSectionDivider.propTypes = {
  tableDepth: number,
}

const useStyle = makeStyles(( theme ) => ({
  root: {
    zIndex: 4,
    backgroundColor: theme.palette.border,
    position: "absolute",
    bottom: 0,
    marginLeft: ({ tableDepth }) => CELL_WIDTHS.DRAG_HANDLE + CELL_WIDTHS.EXPAND.DEPTH_1 - CELL_PADDING*(tableDepth-1),
    width: ({ tableDepth }) => `calc(100% + var(--container-width) - ${CELL_WIDTHS.DRAG_HANDLE + CELL_WIDTHS.EXPAND.DEPTH_1 - CELL_PADDING*(tableDepth-1)}px)`,
    minWidth: CELL_WIDTHS.TITLE_NORMAL
  },
}));